import { Box, Grid, Typography, IconButton } from "@mui/material";
import { Edit } from "@mui/icons-material";

type ProjectKeyValueRowProps = {
    label: React.ReactNode;
    value: React.ReactNode;
    multiline?: boolean;
    labelCols?: number; // domyślnie 2
    valueCols?: number; // domyślnie 10
    showEdit?: boolean;
    onEdit?: () => void;
};

export const ProjectKeyValueRow = ({
    label,
    value,
    multiline = false,
    labelCols = 2,
    valueCols = 10,
    showEdit = false,
    onEdit,
}: ProjectKeyValueRowProps) => (
    <Grid
        container
        spacing={1.5}
        alignItems="stretch"
        sx={{
            py: 0.75,
            borderBottom: (t) => `1px dashed ${t.palette.divider}`,
            "&:last-of-type": { borderBottom: "none" },
        }}
    >
        {/* label */}
        <Grid item xs={12} sm={labelCols}>
            <Box
                sx={(t) => ({
                    bgcolor: t.palette.grey[100],
                    border: `1px solid ${t.palette.grey[200]}`,
                    borderRadius: 1,
                    px: 1,
                    py: 0.75,
                    height: "100%",
                    display: "flex",
                    alignItems: multiline ? "flex-start" : "center",
                })}
            >
                {typeof label === "string" ? (
                    <Typography
                        variant="body2"
                        fontWeight={600}
                        component="span"
                        color="text.secondary"
                    >
                        {label}
                    </Typography>
                ) : (
                    label
                )}
            </Box>
        </Grid>

        {/* value + ewentualny ołówek */}
        <Grid item xs={12} sm={valueCols}>
            <Box
                sx={(t) => ({
                    border: `1px solid ${t.palette.grey[200]}`,
                    bgcolor: t.palette.grey[50],
                    borderRadius: 1,
                    px: 1.25,
                    py: 0.75,
                    height: "100%",
                    display: "flex",
                    alignItems: multiline ? "flex-start" : "center",
                })}
            >
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        variant="body1"
                        fontWeight={600}
                        component={multiline ? "div" : "span"} 

                        sx={multiline ? { whiteSpace: "pre-line" } : undefined}
                    >
                        {value}
                    </Typography>
                </Box>

                {showEdit && onEdit && (
                    <IconButton
                        size="small"
                        onClick={onEdit}
                        sx={{ ml: 1 }}
                    >
                        <Edit fontSize="small" />
                    </IconButton>
                )}
            </Box>
        </Grid>
    </Grid>
);
